import React from "react";

const ProductSkeleton = ({ height = "h-[150px]" }) => {
  return (
    <div className="w-full pb-4 bg-gray-100 rounded-xl relative overflow-hidden h-full animate-pulse">
      {/* Tags area skeleton */}
      <div className="absolute top-[15px] left-[15px] z-[100]">
        <div className="h-6 bg-gray-300 rounded-full w-16"></div>
      </div>
      
      {/* Image skeleton */}
      <div className={`${height} bg-gray-300 relative overflow-hidden rounded-md`}></div>
      
      <div className="p-4 flex flex-col h-[100px]">
        {/* Category skeleton */}
        <div className="mb-1 h-4 bg-gray-300 rounded w-1/3"></div>
        
        {/* Name skeleton - single line */}
        <div className="mb-2 h-6 bg-gray-300 rounded w-full"></div>
        
        {/* Price skeleton */}
        <div className="mt-auto flex space-x-3 items-center">
          <div className="h-5 bg-gray-300 rounded w-16"></div>
          <div className="h-4 bg-gray-300 rounded w-12"></div>
        </div>
      </div>
    </div>
  );
};

export default ProductSkeleton;